import * as React from "react";
import { useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Container, Grid, List, ListItem, Skeleton } from "@mui/material";
import ProductDenomination from "./ProductDenomination";
import "../styles/productDetailTabView.css";
import ProductRedeemVideo from "./ProductRedeemVideo";
import { useSelector } from "react-redux";

function CustomTabPanel(props) {
  const { children, value, index, outOfStock, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ px: 0 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ProductDetailTabView = ({ pageLoading}) => {
  const [value, setValue] = useState(0);
  const PRODUCTDETAILS = useSelector((state) => state.ProductDetail?.allData);
  const handleChange = (event, newValue) => {
    event.preventDefault();
    setValue(newValue);
  };

  React.useEffect(() => {
    if (value !== 0) setValue(0);
  }, [pageLoading]);

  // Show Loading Skeleton
  if (pageLoading) {
    return (<Skeleton variant="rectangular" animation="wave" width="100%" height="350px"
      sx={{
        mt: {
          xs: 3,
          lg: 0
        },
        mb: {
          xs: 3
        },
        borderRadius: 2,
        boxShadow: 3
      }}>
    </Skeleton>);
  }

  return (
    <Container maxWidth="xl"
      sx={{
        px: { xs: ".5rem", sm: 1 },
        backgroundColor: "transparent",
        borderRadius: "0 0 14px 14px",
        mt: 0,
        mb: { xs: "1rem", sm: "2rem" },
      }}>
      <Grid
        container
        sx={{
          backgroundColor: "transparent",
          pt: {
            xs: 0,
            sm: 3,
            lg: 0
          },
          pb: {
            xs: 0,
            sm: 3

          },
          px: { xs: 0, sm: 2 },
          borderRadius: 3,
          justifyContent: {
            xs: "space-between",
            md: "center",
            lg: "space-between"
          },
          alignItems: {
            xs: "flex-start",
            md: "flex-start",
            lg: "flex-start"
          }
        }}
      >
        <Grid item xs={12} sm={12} lg={12} sx={{ mb: 2, px: { xs: 0, lg: 1 }, display: "flex", flexDirection: "column", justifyContent: "center" }}>
          <Box sx={{ borderBottom: 1, mb: 1, borderColor: "primary.main" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab
                label={
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 400,
                    }}>
                    Overview
                  </Typography>
                }
                {...a11yProps(0)}
                sx={{
                  fontSize: { xs: ".8rem", sm: ".8rem", lg: "1.1rem" },
                  textTransform: { xs: "capitalize", sm: "capitalize" },
                  fontWeight: { xs: 400, sm: 500, lg: 500 },
                  pl: { xs: 1, sm: 1, lg: 2 }
                }}
              />
              <Tab
                label={
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 400,
                    }}>
                    How To Redeem ?
                  </Typography>
                }
                {...a11yProps(1)}
                sx={{
                  fontSize: { xs: ".8rem", sm: ".8rem", lg: "1.1rem" },
                  textTransform: { xs: "capitalize", sm: "capitalize" },
                  fontWeight: { xs: 400, sm: 500, lg: 500 },
                  pl: { xs: 1, sm: 1, lg: 2 }
                }}
              />
              <Tab
                label={
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 400,
                    }}>
                    Redeem Video
                  </Typography>
                }
                {...a11yProps(2)}
                sx={{
                  fontSize: { xs: ".8rem", sm: ".8rem", lg: "1.1rem" },
                  textTransform: { xs: "capitalize", sm: "capitalize" },
                  fontWeight: { xs: 400, sm: 500, lg: 500 },
                  pl: { xs: 1, sm: 1, lg: 2 }
                }}
              />
              <Tab
                label={
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 400,
                    }}>
                    Terms And Conditions
                  </Typography>
                }
                {...a11yProps(3)}
                sx={{
                  fontSize: { xs: ".8rem", sm: ".8rem", lg: "1.1rem" },
                  textTransform: { xs: "capitalize", sm: "capitalize" },
                  fontWeight: { xs: 400, sm: 500, lg: 500 },
                  pl: { xs: 1, sm: 1, lg: 2 }
                }}
              />
              <Tab
                label={
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 400,
                    }}>
                    More Info
                  </Typography>
                }
                {...a11yProps(4)}
                sx={{
                  fontSize: { xs: ".8rem", sm: ".8rem", lg: "1.1rem" },
                  textTransform: { xs: "capitalize", sm: "capitalize" },
                  fontWeight: { xs: 400, sm: 500, lg: 500 },
                  pl: { xs: 1, sm: 1, lg: 2 }
                }}
              />
            </Tabs>
          </Box>

          <CustomTabPanel value={value} index={0} >
            {PRODUCTDETAILS.outOfStock ?
              <Box sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "white.light",
                minHeight: {
                  xs: "40px",
                  sm: "40px",
                  lg: "60px"
                },
                borderRadius: {
                  xs: 1
                }
              }}>
                <Typography variant="body1"
                  sx={{
                    fontSize: {
                      xs: "1.2vw",
                      sm: "1.62vw",
                      lg: "1.8vw",
                    },
                    color: "primary.main",


                  }}>
                  Out of Stock
                </Typography>
              </Box>
              :
              <ProductDenomination />
            }
          </CustomTabPanel>

          <CustomTabPanel value={value} index={1}>
            {PRODUCTDETAILS?.redeem?.trim()?.length ? (
              <Box
                component="div"
                dangerouslySetInnerHTML={{ __html: PRODUCTDETAILS?.redeem }}
                style={{
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  overflowX: "auto",
                  maxWidth: "100%",
                  boxSizing: "border-box",
                  wordSpacing: "0px",
                  textIndent: "revert-layer",
                  fontFamily: "Celias",
                }}

                sx={{
                  mt: 1,
                  fontSize: { xs: "0.9rem", lg: "13.5px" },
                  lineHeight: { xs: "16px", lg: "2rem" },
                  color: "dark.main2",
                  fontWeight: { xs: 400, lg: 400 },
                  paddingInlineStart: "10px",
                  fontFamily: "Celias",
                }}
              />
            )
              :
              (
                <Box sx={{
                  display: "flex",
                  justifyContent: "center",
                }}>
                  <Box sx={{
                    width: {
                      lg: "40vw",
                    },
                    height: '130px',
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}>
                    <Typography variant="body1" sx={{
                      fontSize: "22px",
                      fontWeight: 500,
                      color: "primary.main",
                      textAlign: "center"
                    }}>
                      ! How To Redeem Infomation is Not Available Contact to our Support.
                    </Typography>
                  </Box>

                </Box>
              )
            }
          </CustomTabPanel>

          <CustomTabPanel value={value} index={2}>
            {PRODUCTDETAILS?.youtube ? (
              <ProductRedeemVideo videoId={PRODUCTDETAILS?.youtube} />
            )
              :
              (
                <Box sx={{
                  display: "flex",
                  justifyContent: "center",
                }}>
                  <Box sx={{
                    width: {
                      lg: "40vw",
                    },
                    height: '130px',
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}>
                    <Typography variant="body1" sx={{
                      fontSize: "22px",
                      fontWeight: 500,
                      color: "primary.main"
                    }}>
                      ! No Video Available
                    </Typography>
                  </Box>

                </Box>
              )
            }
          </CustomTabPanel>

          <CustomTabPanel value={value} index={3}>
            {PRODUCTDETAILS?.terms?.trim()?.length ? (
              <List>
                <ListItem>
                  <Box
                    component="pre"
                    dangerouslySetInnerHTML={{ __html: PRODUCTDETAILS?.terms }}
                    style={{
                      whiteSpace: "pre-wrap",
                      wordWrap: "break-word",
                      overflowX: "auto",
                      maxWidth: "100%",
                      boxSizing: "border-box",
                      wordSpacing: "0px",
                      textIndent: "revert-layer",
                      fontFamily: "Celias",
                    }}
                    sx={{
                      mt: 1,
                      fontSize: { xs: "0.9rem", lg: "1.2rem" },
                      lineHeight: { xs: "16px", lg: "2.3rem" },
                      color: "dark.main",
                      fontWeight: { xs: 400, lg: 400 },
                    }}
                  />
                </ListItem>
              </List>
            )
              :
              (
                <Box sx={{
                  display: "flex",
                  justifyContent: "center",
                }}>
                  <Box sx={{
                    width: {
                      lg: "40vw",
                    },
                    height: '130px',
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}>
                    <Typography variant="body1" sx={{
                      fontSize: "22px",
                      fontWeight: 500,
                      color: "primary.main"
                    }}>
                      ! Term and Conditions Not Available
                    </Typography>
                  </Box>

                </Box>
              )
            }
          </CustomTabPanel>

          <CustomTabPanel value={value} index={4}>
            {PRODUCTDETAILS?.moreInfo?.trim()?.length ? (
              <List>
                <ListItem>
                  <Box
                    component="div"
                    dangerouslySetInnerHTML={{ __html: PRODUCTDETAILS?.['moreInfo'] || null }}
                    style={{
                      whiteSpace: "initial",
                      wordWrap: "break-word",
                      overflowX: "auto",
                      maxWidth: "100%",
                      boxSizing: "border-box",
                      wordSpacing: "0px",
                      textIndent: "revert-layer",
                      fontFamily: "Celias",
                    }}
                    sx={{
                      mt: 1,
                      fontSize: { xs: "0.9rem", lg: "1.2rem" },
                      lineHeight: { xs: "16px", lg: "2.3rem" },
                      color: "dark.main",
                      fontWeight: { xs: 400, lg: 400 },
                    }}
                  />
                </ListItem>
              </List>
            )
              :
              (
                <Box sx={{
                  display: "flex",
                  justifyContent: "center",
                }}>
                  <Box sx={{
                    width: {
                      lg: "40vw",
                    },
                    height: '130px',
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}>
                    <Typography variant="body1" sx={{
                      fontSize: "22px",
                      fontWeight: 500,
                      color: "primary.main"
                    }}>
                      ! More Infomation is Not Available
                    </Typography>
                  </Box>

                </Box>
              )
            }
          </CustomTabPanel>

        </Grid>
      </Grid>
    </Container>
  );
};

export default ProductDetailTabView;
